/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const reserveSlice = createSlice({
  name: 'reserve',
  initialState: {
    lgCd: '',
    timearea: '',
    business: {},
    recItem: [],
    rsvDate: '',
    rsvDateWithTime: '',
    rsvDayOfWeek: '',
    rsvFlameId: '',
    userName: '',
    address: '',
    birthday: '',
    telNum: '',
    mailAddress: '',
    numOfAttendees: 0,
    note: '',
    rsvSetId: '',
    sendType: 1,
    place: { id: '', name: '', address: '', subAddress: '', tel: '' },
    useHome: true,
    rsvFlag: 0,
    hasSelectedPlace: false, // SelectPlace で何かを選択したかどうか
    answerList: [],
    baseName: '',
    summaryPanelOpen: true, // SelectionSummary: PCパネルの開閉状態（画面遷移をまたいで保持する）
    summaryExpanded: false, // SelectionSummary: スマホバーの展開/折りたたみ状態（画面遷移をまたいで保持する）
  },
  reducers: {
    // save: (state, action) => {
    //   // state.keycloak = action.payload.keycloak;
    //   state.lclGov = action.payload.lclGov;
    //   state.timearea = action.payload.timearea;
    //   state.business = action.payload.business;
    //   state.recItem = action.payload.recItem;
    //   state.rsvDate = action.payload.rsvDate;
    //   state.rsvFlameId = action.payload.rsvFlameId;
    // },
    saveLgCd: (state, action) => {
      state.lgCd = action.payload.lgCd;
    },
    saveTimearea: (state, action) => {
      state.timearea = action.payload.timearea;
      state.rsvDate = action.payload.rsvDate;
      state.rsvDateWithTime = action.payload.rsvDateWithTime;
      state.rsvDayOfWeek = action.payload.rsvDayOfWeek;
      state.rsvFlameId = action.payload.rsvFlameId;
    },
    saveBusiness: (state, action) => {
      state.business = action.payload.business;
      state.recItem = action.payload.recItem;
      state.rsvSetId = action.payload.rsvSetId;
      state.formSetId = action.payload.formSetId;
    },
    saveUserInfo: (state, action) => {
      state.userName = action.payload.userName;
      state.address = action.payload.address;
      state.birthday = action.payload.birthday;
      state.telNum = action.payload.telNum;
      state.mailAddress = action.payload.mailAddress;
      state.numOfAttendees = action.payload.numOfAttendees;
      state.note = action.payload.note;
      state.sendType = action.payload.sendType;
    },
    saveCustomUserInfo: (state, action) => {
      state.mailAddress = action.payload.mailAddress;
      state.numOfAttendees = action.payload.numOfAttendees;
      state.note = action.payload.note;
      state.sendType = action.payload.sendType;
      state.telNum = action.payload.telNum;
      state.answerList = action.payload.answerList;
      state.baseName = action.payload.baseName;
    },
    savePlace: (state, action) => {
      state.place.id = action.payload.id;
      state.place.name = action.payload.name;
      state.place.address = action.payload.address;
      state.place.subAddress = action.payload.subAddress;
      state.place.tel = action.payload.tel;
      state.useHome = action.payload.useHome;
      state.rsvFlag = action.payload.rsvFlag;
      state.hasSelectedPlace = true; // 選択済みフラグをセット
      if (action.payload.numOfAttendees !== undefined) {
        state.numOfAttendees = action.payload.numOfAttendees;
      }
    },
    // 日付選択画面に入った時に前回の選択を消すためのアクション
    // rsvDate / rsvDayOfWeek / rsvDateWithTime をリセットすることで
    // SelectionSummary の「利用日」「利用時間」欄が非表示になる
    clearDate: (state) => {
      state.rsvDate = '';
      state.rsvDayOfWeek = '';
      state.rsvDateWithTime = '';
      state.timearea = '';
      state.rsvFlameId = '';
    },
    // 時間選択画面に入った時に前回の選択を消すためのアクション
    // rsvDateWithTime だけリセット → 「利用日」は残り「利用時間」だけ非表示になる
    clearTime: (state) => {
      state.rsvDateWithTime = '';
      state.timearea = '';
      state.rsvFlameId = '';
    },
    // 場所選択画面に入った時に前回の選択を消すためのアクション
    // SelectionSummary が hasSelectedPlace を見て場所を表示するので、
    // false に戻すだけで「場所」欄が非表示になる
    clearPlace: (state) => {
      state.place = { id: '', name: '', address: '', subAddress: '', tel: '' };
      state.useHome = true;
      state.rsvFlag = 0;
      state.hasSelectedPlace = false;
    },
    clear: (state) => {
      // state.lgCd = '';
      state.timearea = '';
      state.business = {};
      state.recItem = [];
      state.rsvDate = '';
      state.rsvDateWithTime = '';
      state.rsvDayOfWeek = '';
      state.rsvFlameId = '';
      state.userName = '';
      state.address = '';
      state.birthday = '';
      state.telNum = '';
      state.mailAddress = '';
      state.numOfAttendees = 0;
      state.note = '';
      state.rsvSetId = '';
      state.sendType = 1;
      state.place = { id: '', name: '', address: '', subAddress: '', tel: '' };
      state.useHome = true;
      state.rsvFlag = 0;
      state.hasSelectedPlace = false; // リセット時は未選択に戻す
      state.answerList = [];
      state.baseName = '';
    },
    setSummaryPanelOpen: (state, action) => {
      state.summaryPanelOpen = action.payload;
    },
    setSummaryExpanded: (state, action) => {
      state.summaryExpanded = action.payload;
    },
  },
});

export const {
  saveLgCd,
  saveTimearea,
  saveBusiness,
  saveUserInfo,
  savePlace,
  clearPlace,
  clearDate,
  clearTime,
  saveCustomUserInfo,
  clear,
  setSummaryPanelOpen,
  setSummaryExpanded,
} = reserveSlice.actions;
export const reserveReducer = reserveSlice.reducer;
